export const OPEN_MODAL = 'tru/modals/OPEN_MODAL'
export const CLOSE_MODAL = 'tru/modals/CLOSE_MODAL'

export const openModal = id => ({ type: OPEN_MODAL, id })
export const closeModal = id => ({ type: CLOSE_MODAL, id })



// WEBPACK FOOTER //
// ../src/actions/modalActions.js